import { render } from "./_containerLoader.vue?vue&type=template&id=ea2d408e&scoped=true"
const script = {}

import "./_containerLoader.vue?vue&type=style&index=0&id=ea2d408e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ea2d408e"]])

export default __exports__